// src/services/automationService.js
import api from "./Api";

const PATH = "/Automatizacion";
const PATH_VALORES = "/valores-referencia";

// Listar reglas (opcional: filtrar por sensorId)
export const listarReglas = async (sensorId, options = {}) => {
  const params = {};
  if (sensorId !== undefined && sensorId !== null && `${sensorId}` !== "") {
    params.sensorId = sensorId;
  }
  if (options.estanqueId) params.estanqueId = options.estanqueId;
  if (options.archivadas) params.archivadas = true;
  const { data } = await api.get(`${PATH}/reglas`, { params });
  return data; // [{id, sensorId, efectorId, ...}]
};

// Crear
export const crearRegla = async (payload) => {
  const { data } = await api.post(`${PATH}/reglas`, payload);
  return data;
};

// Actualizar
export const actualizarRegla = async (id, payload) => {
  const { data } = await api.put(`${PATH}/reglas/${id}`, payload);
  return data;
};

// Eliminar
export const eliminarRegla = async (id) => {
  const { data } = await api.delete(`${PATH}/reglas/${id}`);
  return data;
};

export const archivarRegla = async (id) => (await api.post(`${PATH}/reglas/${id}/archivar`)).data;
export const recuperarRegla = async (id) => (await api.post(`${PATH}/reglas/${id}/recuperar`)).data;

/**
 * Toggle tolerante:
 * 1) PATCH /reglas/{id}/toggle
 * 2) Si no existe (404/405/501), fallback a PUT /reglas/{id}
 *    con la regla completa y estaActivo invertido.
 */
export const toggleRegla = async (id) => {
  try {
    const { data } = await api.patch(`${PATH}/reglas/${id}/toggle`, {});
    return data;
  } catch (err) {
    const status = err?.response?.status;
    if (![404, 405, 501].includes(status)) throw err;

    // Fallback: obtener reglas y armar payload completo
    const { data: todas } = await api.get(`${PATH}/reglas`);
    const regla = (todas || []).find((r) => String(r.id ?? r.Id) === String(id));
    if (!regla) throw err;

    const payload = {
      sensorId: Number(regla.sensorId ?? regla.SensorId),
      efectorId: Number(regla.efectorId ?? regla.EfectorId),
      rangoObjetivo: Number(regla.rangoObjetivo ?? regla.RangoObjetivo),
      accion: Number(regla.accion ?? regla.Accion),
      histeresis: regla.histeresis ?? regla.Histeresis ?? null,
      minDuracionOnSeg: regla.minDuracionOnSeg ?? regla.MinDuracionOnSeg ?? null,
      minDuracionOffSeg: regla.minDuracionOffSeg ?? regla.MinDuracionOffSeg ?? null,
      estaActivo: !(regla.estaActivo ?? regla.EstaActivo),
    };

    const { data: putData } = await api.put(`${PATH}/reglas/${id}`, payload);
    return putData;
  }
};

// Opcional: mostrar rangos de referencia en la UI (compat con controlador viejo)
export const obtenerValorReferenciaPorTipo = async (tipoParametroId, sensorId) => {
  const { data } = await api.get(`${PATH_VALORES}/tipo/${tipoParametroId}`, {params: {sensorId}});
  // { unidad, optimoMin, optimoMax, aceptableMin, ... }
  return data;
};

const automationService = {
  listarReglas,
  crearRegla,
  actualizarRegla,
  eliminarRegla,
  archivarRegla,
  recuperarRegla,
  toggleRegla,
  obtenerValorReferenciaPorTipo,
};

export default automationService;
